import axios from 'axios'

function unwrapList(res) {
  const d = res?.data ?? res
  if (!d) return []
  if (Array.isArray(d)) return d
  if (Array.isArray(d.data)) return d.data
  if (Array.isArray(d.rows)) return d.rows
  if (Array.isArray(d.items)) return d.items
  return []
}

function unwrapOne(res) {
  const d = res?.data ?? res
  if (!d) return null
  if (d.data && typeof d.data === 'object') return d.data
  return d
}

function str(v) {
  return String(v ?? '').trim()
}

const SchedulesService = {
  async list(params = {}) {
    return axios.get('schedules', { params })
  },

  async get(id, params = {}) {
    if (!id) throw new Error('Missing schedule id')
    return axios.get(`schedules/${encodeURIComponent(id)}`, { params })
  },

  async create(payload = {}) {
    return axios.post('schedules', payload)
  },

  async update(id, payload = {}) {
    if (!id) throw new Error('Missing schedule id')
    return axios.put(`schedules/${encodeURIComponent(id)}`, payload)
  },

  async destroy(id) {
    if (!id) throw new Error('Missing schedule id')
    return axios.delete(`schedules/${encodeURIComponent(id)}`)
  },

  async test(id, payload = {}) {
    if (!id) throw new Error('Missing schedule id')
    return axios.post(`schedules/${encodeURIComponent(id)}/test`, payload)
  },

  unwrapList,
  unwrapOne
}

export default SchedulesService
